import { useState, useEffect } from 'react';
import { ArrowDownIcon } from '@heroicons/react/24/outline';
import { Product } from '../types';
import ProductCard from '../components/ProductCard';
import { useScrollReveal } from '../hooks/useScrollReveal';

const Home = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const containerRef = useScrollReveal([loading]);

  useEffect(() => {
    fetchHomeData();
  }, []);

  const fetchHomeData = async () => {
    try {
      const productsRes = await fetch('/api/products?limit=100');
      const productsData = await productsRes.json();
      if (productsData.success) {
        setProducts(productsData.data.products || []);
      }
    } catch (error) {
      // Silently fail — page is still usable with empty state
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-offwhite">
        <div className="spinner-lg" />
      </div>
    );
  }

  return (
    <div ref={containerRef} className="bg-offwhite">

      {/* ═══════ HERO ═══════ */}
      <section className="relative h-[60svh] min-h-[400px] flex items-center justify-center bg-offblack overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-offblack via-charcoal to-offblack" />
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }} />
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <div className="animate-fade-in-up" style={{ animationDelay: '0.1s', animationFillMode: 'both' }}>
            <img src="/arme logo.png" alt="La Maison Armé"
              className="w-80 h-80 md:w-[420px] md:h-[420px] mx-auto mb-8"
              style={{ filter: 'invert(1) grayscale(1) brightness(2)', mixBlendMode: 'screen' }} />
          </div>
          <div className="animate-fade-in-up" style={{ animationDelay: '0.2s', animationFillMode: 'both' }}>
            <p className="text-[0.6rem] uppercase tracking-[0.35em] text-white mb-6 font-sans font-bold">
              Premium Jeans & Shoes
            </p>
          </div>
        </div>
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <ArrowDownIcon className="h-5 w-5 text-warmgray-400" />
        </div>
      </section>

      {/* ═══════ ALL PRODUCTS ═══════ */}
      {products.length > 0 && (
        <section className="section bg-white">
          <div className="section-wide">
            <div className="mb-12 reveal">
              <p className="text-[0.6rem] uppercase tracking-[0.25em] text-warmgray-400 mb-2 font-sans">Our Products</p>
              <h2 className="section-title">Shop All</h2>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {products.map((product, index) => (
                <ProductCard key={product._id} product={product} index={index} />
              ))}
            </div>
          </div>
        </section>
      )}



    </div>
  );
};

export default Home;
